import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {UserRoleCode} from '../../types/user-role-codes/roleCodes';
import {Role} from '../../types/user-roles/roles';

interface RoleListState {
  roles: Role[];
}

const initialState: RoleListState = {
  roles: [],
};

const roleListSlice = createSlice({
  name: 'roleList',
  initialState,
  reducers: {
    setRoles(state, action: PayloadAction<RoleListState>) {
      state.roles = action.payload.roles;
    },
  },
  selectors: {
    getRoles(state) {
      if (state.roles)
        return state.roles
          .filter(
            (items) =>
              ![UserRoleCode.systemAdminUserRole.toString()].includes(
                items?.roleCode
              )
          )
          .map((value) => ({
            name: value?.name,
            id: value?.roleId,
            roleCode: value?.roleCode,
          }));
    },
  },
});

export const {setRoles} = roleListSlice.actions;
export const {getRoles} = roleListSlice.selectors;

export default roleListSlice.reducer;
